import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import { FaCookieBite, FaInfoCircle, FaChartLine, FaCogs, FaBullseye, FaGlobe, FaUserShield, FaSyncAlt, FaPhoneAlt,FaCheckCircle } from "react-icons/fa";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";

export default function Cookie() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* NavbarSticky */}
            <Navbarsticky />
            <div className="cookie-container">
            </div>

            {/* MAIN CONTENT */}
            <div className="cookie-section py-5 w-100">
                <Container fluid className="w-100">
                    <Row className="justify-content-center">
                        <h1 className="cookie-title">
                            <FaCookieBite className="title-icon" />
                            Cookies Policy
                        </h1>
                        <Col lg={9} md={11}>
                            <div className="cookie-card">
                                  <p className="cookie-subtitle">Last Updated: On</p>
                                <p>
                                    This Cookies Policy explains how <strong>https://andamanmakeholidays.com</strong>
                                    (“we”, “our”, “us”) uses cookies and similar technologies to enhance your
                                    experience on our travel booking platform.
                                </p>

                                <p>
                                    By continuing to use our website, you agree to the use of cookies as
                                    described in this policy.
                                </p>

                                {/* 1. What Are Cookies */}
                                <div className="cookie-block">
                                    <h5>
                                        <FaInfoCircle className="block-icon" />
                                        What Are Cookies?
                                    </h5>
                                </div>

                                <p>
                                    Cookies are small text files stored on your device (computer, smartphone,
                                    tablet) when you visit a website. They help us remember your preferences,
                                    improve website performance, and personalize your experience.
                                </p>

                                {/* 2. Types of Cookies */}
                                <div className="cookie-block">
                                    <h4>
                                        <FaCookieBite className="block-icon" />
                                        Types of Cookies We Use
                                    </h4>
                                </div>

                                <h5 className="sub-heading">
                                    <FaUserShield className="bullet-icon" />
                                    Essential Cookies
                                </h5>

                                <p>
                                    These cookies are necessary for the site to function properly. They enable
                                    secure logins, booking flow, and payment processing.
                                </p>
                                <p>Example: Session cookies, authentication cookies</p>

                                <h5 className="sub-heading">
                                    <FaChartLine className="bullet-icon" />
                                    Performance & Analytics Cookies
                                </h5>

                                <p>
                                    These cookies show how visitors interact with our website, helping improve
                                    site speed and performance.
                                </p>
                                <p>Example: Google Analytics cookies</p>

                                <h5 className="sub-heading">
                                    <FaCogs className="bullet-icon" />
                                    Functional Cookies
                                </h5>

                                <p>
                                    These remember your preferences like language, currency, and past searches,
                                    enabling a personalized experience.
                                </p>

                                <h5 className="sub-heading">
                                    <FaBullseye className="bullet-icon" />
                                    Advertising & Marketing Cookies
                                </h5>

                                <p>
                                    These deliver relevant ads across platforms and track marketing campaign
                                    performance.
                                </p>
                                <p>Example: Facebook Pixel, Google Ads cookies</p>

                                {/* 3. Third-Party Cookies */}
                                <div className="cookie-block">
                                    <h4>
                                        <FaGlobe className="block-icon" />
                                        Third-Party Cookies
                                    </h4>
                                </div>

                                <p>
                                    Some cookies are placed by third-party services used for analytics,
                                    marketing, or payment processing. These services have their own cookie
                                    policies.
                                </p>

                                <p>We do not control or access these cookies.</p>

                                {/* 4. How to Control Cookies */}
                                <div className="cookie-block">
                                    <h4>
                                        <FaUserShield className="block-icon" />
                                        How to Control Cookies
                                    </h4>
                                </div>

                                <p>
                                    You can manage or disable cookies through your browser settings.
                                    However, disabling cookies may affect website functionality.
                                </p>

                                {/* 5. Consent for Cookies */}
                                <div className="cookie-block">
                                    <h4>
                                        <FaCheckCircle className="block-icon" />
                                        Consent for Cookies
                                    </h4>
                                </div>

                                <p>
                                    When you first visit our site, a cookie consent banner is shown.
                                    By clicking “Accept” or continuing to browse, you consent to our cookie
                                    usage.
                                </p>

                                <p>You may withdraw or modify your consent anytime.</p>

                                {/* 6. Changes to Policy */}
                                <div className="cookie-block">
                                    <h4>
                                        <FaSyncAlt className="block-icon" />
                                        Changes to This Policy
                                    </h4>
                                </div>

                                <p>
                                    We may update this policy periodically. Any changes will appear here with
                                    an updated "Last Updated" date.
                                </p>

                                {/* 7. Contact Us */}
                                <div className="cookie-block">
                                    <h4>
                                        <FaPhoneAlt className="block-icon" />
                                        Contact Us
                                    </h4>
                                </div>

                                <p>
                                    For questions about this Cookies Policy:<br />
                                    Email: Andamanmakeholidayss@gmail.com<br />
                                    Phone: +91-8145080001
                                </p>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Footer */}
            <Footer/>
        </>
    );
};
